import { render, staticRenderFns } from "./activeSessions.vue?vue&type=template&id=42a19674"
import script from "./activeSessions.vue?vue&type=script&lang=js"
export * from "./activeSessions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports